import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
const AutocompleteItemComponent = ({ value, translateValue, subLabel, translateSublabel, onItemClick, }) => {
    return (React.createElement("div", { className: "autocomplete-item", key: value, onClick: () => onItemClick(value) },
        translateValue ? getMessage(value) : value,
        ' ',
        subLabel && subLabel.trim().length > 0
            ? `(${translateSublabel ? getMessage(subLabel) : subLabel})`
            : ''));
};
export default AutocompleteItemComponent;
